export function formatBet(bet: number): string {
  return bet === 0 ? '' : String(bet);
}
